import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  linkIndeedFlexLocation,
  type LinkIndeedFlexLocationParams,
} from 'api/admin/indeedFlex/linkIndeedFlexLocation'
import { indeedFlexKeys } from './keys'

export const useLinkIndeedFlexLocationMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: LinkIndeedFlexLocationParams) =>
      linkIndeedFlexLocation(params),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: indeedFlexKeys.shiftIssues(),
      })
      await queryClient.invalidateQueries({
        queryKey: indeedFlexKeys.jobShifts(),
      })
    },
  })
}
